import type { ReactNode } from "react";
import { Box, Card, CardContent } from "@mui/material";

export type AdminTileCardProps = {
  children: ReactNode;
  footer?: ReactNode;
};

export const AdminTileCard = ({ children, footer }: AdminTileCardProps) => (
  <Card
    variant="outlined"
    sx={{ height: "100%", display: "flex", flexDirection: "column" }}
  >
    <CardContent
      sx={{
        p: 1.5,
        flexGrow: 1,
        display: "flex",
        flexDirection: "column",
        gap: 1,
      }}
    >
      {children}
      {footer && (
        <Box
          sx={{
            mt: "auto",
            display: "flex",
            justifyContent: "flex-end",
            gap: 0.5,
          }}
        >
          {footer}
        </Box>
      )}
    </CardContent>
  </Card>
);
